import { render, staticRenderFns } from "./createCoupon.vue?vue&type=template&id=406cb931&scoped=true&"
import script from "./createCoupon.vue?vue&type=script&lang=js&"
export * from "./createCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406cb931",
  null
  
)

export default component.exports